@if (grantsLoading$ | async) {
  <app-page-loader text="Loading..."></app-page-loader>
}
@if (grants$ | async; as grants) {
  @if (grants.length > 1) {
    <app-auth-card size="large" [progress]="setGrantsLoading$ | async">
      <span auth-card-header>Select a Grant</span>
      <div class="grant-content">
        <p>
          Your account has access to all grants listed below. Please select a
          grant to view or submit data:
        </p>
        <app-user-grant-list
          [grants]="grants"
          class="flex-column grant-list"
          (grantSelected)="
            setGrantSelection($event.grantId, $event.subrecipientId)
          "
        ></app-user-grant-list>
      </div>
      <ng-container auth-card-actions>
        <button mat-stroked-button color="primary" (click)="signOut()">
          Sign Out
        </button>
      </ng-container>
    </app-auth-card>
  }
}
